import { render } from "./TestFragment.vue?vue&type=template&id=ac6a0474"
import script from "./TestFragment.vue?vue&type=script&lang=js"
export * from "./TestFragment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__